// MedicalCard.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import QRCode from "react-qr-code";

// Front Card SVG Background
const FrontBackground = () => (
  <svg className="card-bg-geometry" width="100%" height="100%" viewBox="0 0 540 340" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="540" height="340" fill="#ffffff" />
    <polygon points="280,340 490,350 395,220" fill="#00258B" />
    <rect x="435" y="280" width="20" height="95" fill="#00246b" transform="rotate(44 400 165)" />
    <rect x="415" y="280" width="20" height="115" fill="#A8CEE2" transform="rotate(44 400 165)" />
    <polygon points="410,0 495,0 450,48" fillOpacity="0.7" fill="#A8CEE2" />
    <polygon points="420,0 535,0 475,70" fillOpacity="0.8" fill="#0E54C8" />
    <polygon points="465,0 534,0 497,42" fillOpacity="0.9" fill="#00246b" />
    <polygon points="552,-15 602,230 479,73" fill="#0E54C8" />
    <rect x="405" y="75" width="125" height="125" fill="none" stroke="#7F8594" strokeWidth="1.5" strokeLinejoin="miter" strokeMiterlimit="10" rx="0" ry="0" transform="rotate(51 435 132)" />
    <rect x="375" y="240" width="45" height="23" fill="#A8CEE2" transform="rotate(52 479 179)" />
    <rect
      x="427"
      y="148"
      width="40"
      height="21"
      fill="url(#diamondBlue)"
      transform="rotate(141 479 179)"
    />

    <rect
      x="385"
      y="230"
      width="45"
      fill="url(#diamondBlue)"
      height="23"
      transform="rotate(52 479 179)"
    />
    <defs>
      <linearGradient id="diamondBlue" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#00184b" />
        <stop offset="40%" stopColor="#0039b3" />
        <stop offset="100%" stopColor="#00d2ff" />
      </linearGradient>
      <linearGradient id="glassBlue" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#00d2ff" stopOpacity="0.95" />
        <stop offset="50%" stopColor="#0088ff" stopOpacity="0.6" />
      </linearGradient>
      <radialGradient id="shine" cx="30%" cy="20%" r="60%">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.9" />
        <stop offset="40%" stopColor="#ffffff" stopOpacity="0.2" />
        <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
      </radialGradient>
      <filter id="glassGlow">
        <feGaussianBlur stdDeviation="1.5" result="blur" />
        <feMerge>
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g transform="translate(410, 60) scale(1.5)" stroke="url(#glassBlue)" filter="url(#glassGlow)" strokeWidth="2.5" fill="none" strokeLinejoin="round" strokeLinecap="round">
      <path d="M 6 12 V 14 A 4 4 0 0 1 2 18 H -2 A 4 4 0 0 1 -6 14 V 6 H -14 A 4 4 0 0 1 -18 2 V -2 A 4 4 0 0 1 -14 -6 H -6 V -14 A 4 4 0 0 1 -2 -18 H 2 A 4 4 0 0 1 6 -14 V -6 H 14 A 4 4 0 0 1 18 -2 V 2 A 4 4 0 0 1 14 6 H 6 V 6" />
    </g>
    <g transform="translate(310, 230) scale(1.8)" stroke="url(#glassBlue)" filter="url(#glassGlow)" strokeWidth="2.5" fill="none" strokeLinejoin="round" strokeLinecap="round">
      <path d="M 6 12 V 14 A 4 4 0 0 1 2 18 H -2 A 4 4 0 0 1 -6 14 V 6 H -14 A 4 4 0 0 1 -18 2 V -2 A 4 4 0 0 1 -14 -6 H -6 V -14 A 4 4 0 0 1 -2 -18 H 2 A 4 4 0 0 1 6 -14 V -6 H 14 A 4 4 0 0 1 18 -2 V 2 A 4 4 0 0 1 14 6 H 6 V 6" />
    </g>
    <g transform="translate(17, 295) scale(0.8)" stroke="url(#glassBlue)" filter="url(#glassGlow)" strokeWidth="2.5" fill="none" strokeLinejoin="round" strokeLinecap="round">
      <path d="M 6 12 V 14 A 4 4 0 0 1 2 18 H -2 A 4 4 0 0 1 -6 14 V 6 H -14 A 4 4 0 0 1 -18 2 V -2 A 4 4 0 0 1 -14 -6 H -6 V -14 A 4 4 0 0 1 -2 -18 H 2 A 4 4 0 0 1 6 -14 V -6 H 14 A 4 4 0 0 1 18 -2 V 2 A 4 4 0 0 1 14 6 H 6 V 6" />
    </g>
  </svg>
);

// Back Card SVG Background
const BackBackground = () => (
  <svg className="card-bg-geometry" width="100%" height="100%" viewBox="0 0 540 340" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="cardRoundBack">
        <rect width="540" height="340" rx="20" ry="20" />
      </clipPath>
      <linearGradient id="glassBlue" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#00d2ff" stopOpacity="0.95" />
        <stop offset="50%" stopColor="#0088ff" stopOpacity="0.6" />
        <stop offset="100%" stopColor="#001f6b" stopOpacity="0.8" />
      </linearGradient>
      <radialGradient id="shine" cx="30%" cy="20%" r="60%">
        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.9" />
        <stop offset="40%" stopColor="#ffffff" stopOpacity="0.2" />
        <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
      </radialGradient>
      <filter id="glassGlow">
        <feGaussianBlur stdDeviation="1.5" result="blur" />
        <feMerge>
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g clipPath="url(#cardRoundBack)">
      <polygon points="410,0 495,0 450,48" fillOpacity="0.7" fill="#A8CEE2" />
      <polygon points="420,0 535,0 475,70" fillOpacity="0.8" fill="#0E54C8" />
      <polygon points="465,0 534,0 497,42" fillOpacity="0.9" fill="#00246b" />
      <polygon points="552,-15 602,230 479,73" fill="#0E54C8" />
      <g transform="translate(540,-10) scale(-1,1)">
        <polygon points="470,310 540,400 540,210" fill="#0f3b8c" />
        <rect x="548" y="160" width="20" height="85" fill="#01184B" transform="rotate(35 479 179)" />
        <rect x="527" y="125" width="20" height="120" fill="#A8CEE2" transform="rotate(35 479 179)" />
      </g>
      <polygon points="39,355 189,342 129,250" fill="#b8ecff" />
      <polygon points="59,355 209,342 149,250" fill="#00258B" />
      <polygon points="470,320 560,400 540,230" fill="#0f3b8c" />
      <rect x="558" y="220" width="20" height="75" fill="#01184B" transform="rotate(38 479 179)" />
      <rect x="538" y="220" width="20" height="75" fill="#A8CEE2" transform="rotate(38 479 179)" />
      <g transform="translate(395, 80) scale(1.5)" stroke="url(#glassBlue)" filter="url(#glassGlow)" strokeWidth="2.5" fill="none" strokeLinejoin="round" strokeLinecap="round">
        <path d="M 6 12 V 14 A 4 4 0 0 1 2 18 H -2 A 4 4 0 0 1 -6 14 V 6 H -14 A 4 4 0 0 1 -18 2 V -2 A 4 4 0 0 1 -14 -6 H -6 V -14 A 4 4 0 0 1 -2 -18 H 2 A 4 4 0 0 1 6 -14 V -6 H 14 A 4 4 0 0 1 18 -2 V 2 A 4 4 0 0 1 14 6 H 6 V 6" />
      </g>
      <g transform="translate(75, 230) scale(0.55)" stroke="url(#glassBlue)" filter="url(#glassGlow)" strokeWidth="2.5" fill="none" strokeLinejoin="round" strokeLinecap="round">
        <path d="M 6 12 V 14 A 4 4 0 0 1 2 18 H -2 A 4 4 0 0 1 -6 14 V 6 H -14 A 4 4 0 0 1 -18 2 V -2 A 4 4 0 0 1 -14 -6 H -6 V -14 A 4 4 0 0 1 -2 -18 H 2 A 4 4 0 0 1 6 -14 V -6 H 14 A 4 4 0 0 1 18 -2 V 2 A 4 4 0 0 1 14 6 H 6 V 6" />
      </g>
      <g transform="translate(100, 250) scale(1)" stroke="url(#glassBlue)" filter="url(#glassGlow)" strokeWidth="2.5" fill="none" strokeLinejoin="round" strokeLinecap="round">
        <path d="M 6 12 V 14 A 4 4 0 0 1 2 18 H -2 A 4 4 0 0 1 -6 14 V 6 H -14 A 4 4 0 0 1 -18 2 V -2 A 4 4 0 0 1 -14 -6 H -6 V -14 A 4 4 0 0 1 -2 -18 H 2 A 4 4 0 0 1 6 -14 V -6 H 14 A 4 4 0 0 1 18 -2 V 2 A 4 4 0 0 1 14 6 H 6 V 6" />
      </g>
    </g>
  </svg>
);

export default function MedicalCard({ data, isFlipped, frontRef, backRef, onFlip }) {
  const {
    empName,
    empId,
    birthDate,
    bloodGroup,
    familyContact,
    family = [],
    sSWhiteBackImg,
    empPhotoUrl,
    qrCodeUrl,
    signatureUrl,
    logoUrl,
    companyTitleFront,
    companySubtitleFront,
    companyTitleBack,
    companySubtitleBack,
    ssWhiteContacts = [],
    srsContacts = [],
    emergencyContact,
    companyAddress,
    companyNameBack,
    customColorFront,
    customColorBack,
    medicalCard
  } = data || {};

  const cardUrl = medicalCard;

  const formatDate = (date) => {
    if (!date) return "—";
    const datePart = date.split(" ")[0];
    const parts = datePart.split("-");
    if (parts.length !== 3) return datePart;
    const [day, month, year] = parts;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${day.padStart(2, "0")} ${monthNames[Number(month) - 1]} ${year}`;
  };

  return (
    <Box className="card-scene" onClick={onFlip} sx={{ cursor: 'pointer' }}>
      <Box className={`card-flipper ${isFlipped ? 'flipped' : ''}`}>
        {/* FRONT FACE */}
        <Box ref={frontRef} id="medical-card-front" className="medical-card-face card-front-face">
          <FrontBackground />
          <Box className="card-content">
            <Box className="card-header">
              <Box className="card-logo-container" sx={{ width: '100%' }}>
                {logoUrl ? (
                  <Box component="img" src={logoUrl} alt="Logo" sx={{ height: 56, maxWidth: '100%', objectFit: 'contain', transform: 'translate(-9px)' }} />
                ) : (
                  <>
                    <Box component="svg" className="card-logo-icon" viewBox="0 0 120 120" sx={{ width: 48, height: 48, flexShrink: 0 }}>
                      <path d="M90,35 C90,20 75,15 60,15 C40,15 30,28 30,42 C30,65 90,55 90,82 C90,98 75,105 60,105 C40,105 25,92 25,78" fill="none" stroke={customColorFront || '#0088ff'} strokeWidth="16" strokeLinecap="round" />
                      <g transform="translate(60, 60)" fill="#111827">
                        <polygon points="0,-10 8,0 0,10 -8,0" />
                        <polygon points="12,-2 20,8 12,18 4,8" />
                        <polygon points="-12,-18 -4,-8 -12,2 -20,-8" />
                      </g>
                    </Box>
                    <Box className="card-logo-text">
                      <Typography className="card-logo-title" sx={{ color: customColorFront || '#002d62' }}>
                        {companyTitleFront || 'SHUKLA MEDICAL'}
                      </Typography>
                      <Typography className="card-logo-subtitle">
                        {companySubtitleFront || 'Universal Orthopedic Extraction Technologies'}
                      </Typography>
                    </Box>
                  </>
                )}
              </Box>
            </Box>

            <Box className="card-body">
              <Typography className="employee-name">{empName || 'Employee Name'}</Typography>
              <Box className="info-grid">
                {[
                  { label: 'Emp ID :', value: empId },
                  { label: 'Birth Date :', value: formatDate(birthDate) },
                  { label: 'Blood Group :', value: bloodGroup },
                  { label: 'Family Contact :', value: familyContact },
                ].map((item, index) => (
                  <Box className="info-row" key={index}>
                    <Typography component="span" className="info-label">{item.label}</Typography>
                    <Typography component="span" className="info-value">{item.value || '—'}</Typography>
                  </Box>
                ))}
                <Box className="info-row family-row">
                  <Typography component="span" className="info-label">Family :</Typography>
                  <Box className="info-value family-list">
                    {Array.isArray(family) && family.length > 0 ? (
                      family.map((member, index) => (
                        <Typography component="div" key={index}>{member}</Typography>
                      ))
                    ) : (
                      ""
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box className="authorized-sign">
              <Typography component="span" mt={2} ml={1} className="auth-label">Authorized Sign</Typography>
              {signatureUrl && (
                <Box component="img" src={signatureUrl} alt="Signature" className="auth-signature" style={{ imageRendering: "auto" }} />
              )}
            </Box>
          </Box>

          {empPhotoUrl && (
            <Box className="employee-photo-frame">
              <img
                key={empPhotoUrl}
                src={empPhotoUrl}
                alt={empName || "Employee"}
                className="employee-photo"
                onLoad={(event) => {
                  event.currentTarget.style.display = "block";
                }}
                onError={(event) => {
                  const image = event.currentTarget;

                  if (
                    image.src.includes("dashboardapi.sswhite.co") &&
                    empId
                  ) {
                    image.onerror = null;
                    image.src = `https://hrms.sswhite.co/pic/${empId}.png`;
                    return;
                  }

                  image.onerror = null;
                  image.style.display = "none";
                }}
              />
            </Box>
          )}
        </Box>

        {/* BACK FACE */}
        <Box ref={backRef} id="medical-card-back" className="medical-card-face card-back-face">
          <BackBackground />
          <Box className="card-content">
            <Box sx={{ width: '100%', height: '80px', overflow: 'hidden' }}>
              <Box component="img" src={sSWhiteBackImg} alt="Employee" sx={{ width: '58%', height: '100%', objectFit: 'fill' }} />
            </Box>

            <Box className="card-back-grid">
              <Box className="card-back-column">
                <Typography className="column-header" sx={{ marginLeft: '10px', backgroundColor: customColorBack || '#002d62' }}>
                  S.S. WHITE
                </Typography>
                {ssWhiteContacts?.map((contact, index) => (
                  <Box className="contact-entry" key={index}>
                    <Typography component="span" className="contact-name">{contact.name || '—'}</Typography>
                    <Typography component="span" className="contact-phone">{contact.phone || '—'}</Typography>
                  </Box>
                ))}
              </Box>

              <Box className="card-back-column">
                <Typography className="column-header" sx={{ backgroundColor: customColorBack || '#002d62' }}>
                  SRS Hospital
                </Typography>
                {srsContacts?.map((contact, index) => (
                  <Box className="contact-entry" key={index}>
                    <Typography component="span" className="contact-name">{contact.name || '—'}</Typography>
                    <Typography component="span" className="contact-phone">{contact.phone || '—'}</Typography>
                  </Box>
                ))}
                <Box className="emergency-contact-highlight">
                  <Typography component="span" className="emergency-label">Emergency Contact</Typography>
                  <Typography component="span" className="emergency-phone">{emergencyContact || '—'}</Typography>
                </Box>
              </Box>
            </Box>

            {cardUrl && (
              <Box className="back-qr-code">
                <QRCode value={cardUrl} size={120} bgColor="#FFFFFF" fgColor="BLACK" />
              </Box>
            )}

            <Box className="company-footer-details">
              <Typography className="company-name-bold">
                {companyNameBack || 'S.S. White Technologies India Pvt Ltd.'}
              </Typography>
              <Typography className="company-address">
                {companyAddress || 'Address: Survey No. 2788/3, Rajkot-Ahmedabad Hwy, Near Krishna Petrol Pump, Wadhwan, Gujarat 363030'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}